import { Injectable } from '@angular/core';
import { HttpClientService } from '@core/services/http-client/http-client.service';
import { API_URL_CONSTANT } from '@sharedModule/constants/api-url.constant';
import { DataGrid } from '@sharedModule/models/data-grid.model';
import { ResponseIdentity } from '@sharedModule/models/server-response-identity.model';
import { removeEmptyStrings } from '@sharedModule/utils/form.utils';
import { Observable } from 'rxjs';
import { RecipientListInterface } from '../types/recipient-list';
import {
  RecipientListFilter,
  defaultRecipientListFilter,
} from '../types/recipient-list-filter';
import {
  AddRecipientInterface,
  UpdateRecipientInterface,
} from '../types/upsert-recipient';

@Injectable({
  providedIn: 'root',
})
export class RecipientService {
  constructor(private httpClient: HttpClientService) {}

  getRecipientList(
    payload: RecipientListFilter = defaultRecipientListFilter
  ): Observable<ResponseIdentity<DataGrid<RecipientListInterface[]>>> {
    return this.httpClient.post(
      API_URL_CONSTANT.recipient.getRecipientList,
      removeEmptyStrings(payload)
    );
  }

  getRecipientDetails(payload: {
    bene_id: number;
    partner_id?: number;
  }): Observable<ResponseIdentity<RecipientListInterface>> {
    return this.httpClient.post(
      API_URL_CONSTANT.recipient.getRecipientDetails,
      payload
    );
  }

  addRecipient(
    payload: AddRecipientInterface
  ): Observable<ResponseIdentity<null>> {
    return this.httpClient.post(
      API_URL_CONSTANT.recipient.addRecipient,
      payload
    );
  }

  updateRecipient(
    payload: UpdateRecipientInterface
  ): Observable<ResponseIdentity<null>> {
    return this.httpClient.post(
      API_URL_CONSTANT.recipient.updateRecipient,
      payload
    );
  }

  deleteRecipient(payload: {
    partner_id: number;
    sender_id: number;
    bene_id: number;
  }): Observable<ResponseIdentity<null>> {
    return this.httpClient.post(
      API_URL_CONSTANT.recipient.deleteRecipient,
      payload
    );
  }
}
